import { render, staticRenderFns } from "./TypeDate.vue?vue&type=template&id=893c56d6"
import script from "./TypeDate.vue?vue&type=script&lang=js"
export * from "./TypeDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports